// extracted by mini-css-extract-plugin
export default {"root":"PlasmicPaymentRequestButton_root__S5X1P","text":"PlasmicPaymentRequestButton_text__8peU8"};